<script>
import { VideoPlayer } from 'vue-md-player'
import 'vue-md-player/dist/style.css'
import router from "@/router";

export default {
  name: "VideoPage",
  components: { VideoPlayer },
  props: {
    src: String, // تعریف پارامتر src به عنوان props
  },
  setup(props) {

    function end_video() {
      router.push({name:'LoginPage'})
    }

    return {
      // از مقدار props.src به صورت مستقیم استفاده کنید
      video_src: props.src,
      end_video,

    }
  }
}
</script>

<template>

  <div class="dialog max_width p-body">
    <video-player class="" :autoplay="true" :double-click-fullscreen="true" :src="video_src" @ended="end_video"/>
  </div>

</template>

<style scoped>

</style>